<!--页面头部-->
<template>
    <div id="main" ref="main">
        <v-app-bar
            app
            :height="height"
            :style="{
                backgroundImage: navigationMode == 'horizontal' ? 'white' : theme.topBarBgColor,
                borderBottom: '#bfbfbf 2px solid',
                backgroundColor:
                    navigationMode == 'horizontal' ? theme.topBarBgColor : theme.elementBgColor,
            }"
            :color="theme.topBarBgColor"
            flat
            :class="topClass"
            elevation="1"
        >
            <div @click.prevent="moveMenu()">
                <i
                    v-if="showMove"
                    :class="moveIcon"
                    :style="{ fontSize: '4vh', color: theme.pageFontColor }"
                ></i>
            </div>
            <!--返回按钮-->
            <v-chip
                v-if="isJump"
                label
                :color="theme.titleBgColor"
                class="ml-3"
                :text-color="theme.titleFontColor"
                @click="back()"
            >
                <i class="el-icon-arrow-left"></i>
            </v-chip>
            <!-- 首页项目名 -->
            <div
                v-if="isHome"
                :style="{
                    color: theme.projectNameColor,
                    fontSize: '1.9vw',
                    letterSpacing: '0.3vw',
                }"
            >
                美森新能源汽车充电管理平台
				<!-- 新建区节能减排云平台 -->
            </div>
            <!--标题-->
            <v-chip
                label
                :color="theme.titleBgColor"
                class="ml-3"
                :text-color="theme.titleFontColor"
                v-if="title"
            >
                <!--刷新按钮-->
                <v-btn
                    text
                    icon
                    :color="theme.titleFontColor"
                    :loading="loading"
                    @click="refresh()"
                    v-if="isShowRefresh"
                >
                    <v-icon>mdi-cached</v-icon>
                </v-btn>
                <!--其他图标-->
                <v-chip label :color="theme.titleBgColor" :text-color="theme.titleFontColor" v-else>
                    <i :class="icon"></i>
                </v-chip>
                {{ title }}
            </v-chip>
            <!-- 更新价格 -->
            <v-chip
                label
                :color="theme.titleBgColor"
                v-if="title == '互联互通'"
                class="ml-3"
                :text-color="theme.titleFontColor"
            >
                <v-btn
                    text
                    icon
                    :color="theme.titleFontColor"
                    :loading="u_loading"
                    @click="updatePrice()"
                >
                    <v-icon>mdi-cached</v-icon>
                </v-btn>
                更新价格
            </v-chip>
            <!--选择充电站-->
            <select-site
                @choose="chooseSite"
                :selectSite="selectSite"
                :size="'small'"
                :width="'15rem'"
                v-if="isSite"
                class="ml-3"
            />
            <!--选择充电桩-->
            <select-pile
                v-if="isSite"
                v-show="showSelectPile"
                @choose="choosePile"
                :siteId="selectSite"
                :multiple="multiple"
                :width="'16rem'"
                :pileId="pileId"
                ref="selectPile"
                :size="'small'"
                class="ml-1 mr-1"
            />
            <!-- 搜素 -->
            <el-input
                v-if="title != '设置' && title != '运营' && !isHome"
                class="ml-1"
                type="text"
                v-model="searchText"
                placeholder="输入相关内容搜索"
                @keyup.enter.native="OnKeyDown"
                clearable
                style="width:18rem"
                size="small"
            >
                <i
                    class="el-icon-search"
                    style="font-size:1.5em"
                    slot="append"
                    @click="search(searchText)"
                ></i>
            </el-input>
            <v-spacer></v-spacer>
            <!--添加按钮-->
            <v-chip
                label
                :color="theme.titleBgColor"
                v-if="addTitle"
                class="mr-4 chip_font_size"
                :text-color="theme.titleFontColor"
                @click="add()"
            >
                <i class="el-icon-plus mr-1"></i>
                {{ addTitle }}
            </v-chip>
            <v-chip
                label
                :color="theme.titleBgColor"
                v-if="multipleAddTitle"
                class="mr-4 chip_font_size"
                :text-color="theme.titleFontColor"
                @click="multipleAdd()"
            >
                <i class="el-icon-plus  mr-1"></i>
                {{ multipleAddTitle }}
            </v-chip>
            <v-chip
                label
                v-if="reset"
                :color="theme.titleBgColor"
                class="chip_font_size"
                :text-color="theme.titleFontColor"
                @click="resetConnector()"
            >
                <i
                    style="color: red;font-size: 20px;font-weight: 1000"
                    class="el-icon-refresh mr-3"
                ></i>
                重置
            </v-chip>
            <v-chip
                label
                :color="theme.titleBgColor"
                v-if="title == '优惠券'"
                class="chip_font_size"
                :text-color="theme.titleFontColor"
                @click="generateRedeem()"
            >
                <i class="el-icon-connection  mr-1"></i>
                生成兑换码
            </v-chip>
            <div  v-if="isHome" class="mr-8" style="font-size: 1.3vw;" @click="toDataV()">
                <i class="el-icon-full-screen" style="font-size: 1.3vw;"></i>
            </div>
            <!-- 首页告警信息提示 -->
            <div class="mr-7" @click="clickAlrem()" v-if="isHome">
                <el-badge :value="faultNums" :max="30" class="item" id="message">
                    <i class="el-icon-chat-line-round" style="font-size:1.5vw;color:red"></i>
                </el-badge>
            </div>
            <!-- 主题切换 -->
            <div class="mr-6" v-if="isHome">
                <i
                    :class="theme_icon"
                    :style="{ fontSize: '1.6vw', color: theme.userNameColor }"
                    @click="subjectSwitch()"
                ></i>
            </div>
            <!-- 首页显示 用户信息 -->
            <div class="mr-4" v-if="isHome">
                <el-dropdown placement="bottom-end">
                    <span
                        class="el-dropdown-link"
                        :style="{ fontSize: '1.5vw', color: theme.userNameColor }"
                        @mouseenter="move()"
                        @mouseleave="out()"
                        @click="move()"
                    >
                        {{ user.nickname }}
                    </span>
                    <i :class="dropdown_icon" style="font-size:1.1vw;color:#343a40;"></i>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <div class="mr-4" style="font-size: 1.2vw">
                                {{ new Date(user.updatetime * 1000).toLocaleString() }}
                            </div>
                        </el-dropdown-item>
						<v-divider></v-divider>
						<el-dropdown-item>
						    <i class="el-icon-user"></i>
						    {{user.mobile}}
						</el-dropdown-item>
                        <v-divider></v-divider>
                        <el-dropdown-item>
                            <i class="el-icon-lock"></i>
                            {{role == 0 ? '超级管理员' : '管理员'}}
                        </el-dropdown-item>
                        <v-divider></v-divider>
                        <el-dropdown-item>
                            <div @click="logOut()">
                                <i class="el-icon-switch-button"></i>
                                退出登录
                            </div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
			<v-chip
			    label
			    :color="theme.titleBgColor"
			    v-if="isExport"
			    class="mr-4 chip_font_size"
			    :text-color="theme.titleFontColor"
			    @click="exportOrder()"
			>
			    <i class="el-icon-download mr-1"></i>
			    导出订单
			</v-chip>
        </v-app-bar>
    </div>
</template>

<script>
import store from "@/store";
import SelectSite from "@/components/SelectSite";
import SelectPile from "@/components/SelectPile";
import { mapState } from "vuex";
import util from "@/util/index";
import Public from "@/public/index";
export default {
    name: "TopBar",
    data() {
        return {
            screenWidth: document.body.clientWidth, //屏幕尺寸
            showMove: false,
            moveIcon: "el-icon-s-unfold",
            dropdown_icon: "el-icon-arrow-left el-icon--right ml-n2",
            theme_icon: "el-icon-moon",
            topClass: null,
            searchText: null, //在搜索框中输入的内容
        };
    },
    watch: {
        screenWidth(newVal) {
            if (newVal >= 1200 && this.navigationMode === "vertical") {
                store.commit("SET_SHOW_NAVIGATION", true);
                this.showMove = false;
            } else if (newVal >= 1200 && this.navigationMode === "horizontal") {
                store.commit("SET_SHOW_NAVIGATION", false);
                this.showMove = false;
            } else if (newVal <= 1200 && this.navigationMode == "horizontal") {
                store.commit("SET_NAVIGATION_MODE", "vertical");
                store.commit("SET_SHOW_NAVIGATION", true);
            } else {
                this.showMove = true;
                store.commit("SET_NAVIGATION_MODE", "vertical");
                store.commit("SET_SHOW_NAVIGATION", false);
            }
            // location.reload();
        },
        searchText(val) {
            if (!val) {
                this.refresh();
            }
        },
        showNavigation: {
            handler(val) {
                if (this.showMove) {
                    if (val) {
                        this.moveIcon = "el-icon-s-fold";
                    } else {
                        this.moveIcon = "el-icon-s-unfold";
                    }
                }
            },
            deep: true,
        },
    },
    props: {
        height: String, //导航头部高度
        title: String, //标题
        addTitle: String, //添加
        multipleAddTitle: String, // 多个快速添
        icon: null, //显示的其他图标
        pileId: null, //选择的充电桩id
        selectSite: null, //选择的站点id
        loading: Boolean, //加载
        u_loading: Boolean, //互联互通页面 更新价格
        multiple: Boolean, //充电桩是否多选
        isSite: Boolean,
        showSelectPile: Boolean, //是否显示选择充电桩的下拉列表
        isShowRefresh: Boolean, //是否显示刷新按钮
        isHome: Boolean, //是否是首页
        reset: Boolean,  //是否显示重置按钮
        faultNums: Number, //告警消息数量,
		isExport: Boolean  //是否显示导出按钮
    },
    components: {
        SelectSite,
        SelectPile,
    },
    created() {
        if (this.navigationMode == "horizontal") {
            this.topClass = "mt-15";
        }
    },
    mounted() {
        this.refresh();
        this.$refs.main.style.setProperty("--color", this.theme.titleFontColor);
        if (this.isHome) {
            document.getElementById("message").setAttribute("id", "alrem");
            if (this.theme.topBarBgColor == "#2C2C43") {
                this.theme_icon = "el-icon-sunny";
            } else {
                this.theme_icon = "el-icon-moon";
            }
        }
        const that = this;
        window.onresize = () => {
            window.screenWidth = document.body.clientWidth;
            that.screenWidth = window.screenWidth;
        };
        if (this.navigationMode == "vertical" && this.screenWidth < 1200) {
            store.commit("SET_SHOW_NAVIGATION", false);
        } else if (this.navigationMode == "horizontal" && this.screenWidth >= 1200) {
            store.commit("SET_SHOW_NAVIGATION", false);
        } else if (this.navigationMode == "horizontal" && this.screenWidth < 1200) {
            store.commit("SET_NAVIGATION_MODE", "vertical");
            store.commit("SET_SHOW_NAVIGATION", true);
        } else {
            store.commit("SET_SHOW_NAVIGATION", true);
        }
        if (this.screenWidth < 1250) {
            this.showMove = true;
        }
    },
    computed: {
        ...mapState(["isJump", "user", "theme", "navigationMode", "showNavigation","user","role","siteInfo","allArea"]),
    },
    methods: {
        toDataV() {
			if(this.user.name == "xinjian") {
				this.$router.push({
				    name: "XJDataV",
				});
			}else {
				this.$router.push({
				    name: "DataV",
				});
			}
        },
        OnKeyDown(KeyboardEvent) {
            if (KeyboardEvent.key === "Enter") {
                this.search(this.searchText);
            }
        },
		exportOrder() {
			this.$emit("exportOrder");
		},
        /*站点页面搜索*/
        async search(searchText) {
            if (!searchText || searchText == "") {
                await this.refresh();
                return;
            }
            let reg = eval("/" + this.trim(searchText) + "/g");
            this.$emit("search", reg);
        },
        /*主题切换*/
        subjectSwitch() {
            let theme;
            if (this.theme_icon == "el-icon-moon") {
                this.theme_icon = "el-icon-sunny";
                theme = {
                    topBarBgColor: "#2C2C43", // 头部背景颜色
                    projectNameColor: "#F7F7F7", //名称颜色
                    userNameColor: "#A8A9BB", //用户名颜色
                    titleBgColor: "#2C2C43", //标题背景颜色
                    titleFontColor: "#CACBD6", //标题字体颜色
                    navigationDrawerBgColor: "#222233", //左边导航背景颜色
                    navigationDrawerFontColor: "#F4F4F5", //左边导航字体颜色
                    activeDrawerFontColor: "#595959", //左边导航点击后的字体颜色
                    pageBgColor: "#2C2C43", //页面背景颜色
                    pageFontColor: "#A8A9BB", //页面上的字体颜色
                    elementBgColor: "#222233", //页面上的元素背景
                    tableDark: true,
                };
            } else {
                this.theme_icon = "el-icon-moon";
                theme = {
                    topBarBgColor: "white", // 头部背景颜色
                    projectNameColor: "#4dabf7", //名称颜色
                    userNameColor: "#343a40", //用户名颜色
                    titleBgColor: "#4dabf7", //标题背景颜色
                    titleFontColor: "white", //标题字体颜色
                    navigationDrawerBgColor: "#545c64", //左边导航背景颜色
                    navigationDrawerFontColor: "#fff", //左边导航字体颜色
                    activeDrawerFontColor: "#4dabf7", //左边导航点击后的字体颜色
                    pageBgColor: "#e9ecef", //页面背景颜色
                    pageBgColor: "#e9ecef", //页面背景颜色
                    pageFontColor: "#303133", //页面上的字体颜色
                    elementBgColor: "#FFFFFF", //页面上的元素背景
                    tableDark: false,
                };
            }
            store.commit("SET_THEME", theme);
        },
        /*屏幕尺寸较小时切换菜单栏*/
        moveMenu() {
            store.commit("SET_SHOW_NAVIGATION", !this.showNavigation);
        },
        /*返回*/
        back() {
            this.$router.go(-1);
            this.$emit("back");
        },
        /*刷新*/
        refresh() {
            this.$emit("refresh");
        },
        /*添加*/
        add() {
            this.$emit("add");
        },
        /*多个快速添加*/
        multipleAdd() {
            this.$emit("multipleAdd");
        },
        /*选择充电站*/
        chooseSite(site) {
            this.$emit("chooseSite", site);
        },
        /*选择充电桩*/
        choosePile(pile) {
            this.$emit("choosePile", pile);
        },
        /*更新价格*/
        updatePrice() {
            this.$emit("updatePrice");
        },
        /*首页导航中退出登录*/
        logOut() {
            store.commit("LOG_OUT");
        },
        /*首页导航中 鼠标移入用户名*/
        move() {
            this.dropdown_icon = "el-icon-arrow-down  el-icon--right ml-n2";
        },
        /*首页导航中 鼠标移出用户名*/
        out() {
            this.dropdown_icon = "el-icon-arrow-left  el-icon--right ml-n2";
        },
        /*点击首页导航中的故障信息提示*/
        clickAlrem() {
            if (document.getElementById("alrem")) {
                document.getElementById("alrem").removeAttribute("id");
            }
            this.$emit("open");
        },
        //生成兑换码
        generateRedeem() {
            this.$emit("generateRedeem");
        },
        //重置
        resetConnector() {
            this.$emit("resetConnector");
        },
        /*去除左右空格*/
        trim(str) {
            return str.replace(/(^\s*)|(\s*$)/g, "");
        },
    },
};
</script>
<style lang="scss" scoped>
.chip_font_size {
    font-size: 0.8rem !important;
    padding: 0 0.5rem !important;
}
#alrem {
    -webkit-animation: sucaijiayuan 1s 0.1s ease both infinite;
}
@-webkit-keyframes sucaijiayuan {
    0% {
        -webkit-transform: scale(1);
    }
    10%,
    20% {
        -webkit-transform: scale(0.8) rotate(-5deg);
    }
    30%,
    50%,
    70%,
    90% {
        -webkit-transform: scale(1.1) rotate(10deg);
    }
    40%,
    60%,
    80% {
        -webkit-transform: scale(1.1) rotate(-15deg);
    }
    100% {
        -webkit-transform: scale(1) rotate(0);
    }
}
#main {
    --color: #fff;
}
/* Safari，Chrome WebKit browsers */
input::-webkit-input-placeholder {
    color: var(--color);
}
/* 火狐 Mozilla Firefox 4 to 18 */
input:-moz-placeholder {
    color: var(--color);
}
/* 火狐 Mozilla Firefox 19+ */
input::-moz-placeholder {
    color: var(--color);
}
/* Internet Explorer 10+ */
input:-ms-input-placeholder {
    color: var(--color);
}
</style>
